import colors from "./colors.json"

export type NirvanaColors = typeof colors

export const NIRVANA_COLORS: NirvanaColors = colors

export const NIRVANA_THEME = {
    defaultFontSize: 16,
    defaultLineHeight: 24,

    popupIncreasedZIndex: 1081,
    popupDefaultZIndex: 1049,

    mediaQueries: {
        sm: "@media (max-width: 639px)",
        md: "@media (max-width: 1023px)",
        lg: "@media (max-width: 1279px)",
        xl: "@media (max-width: 1535px)",
    },
}
